import * as util from './util.js'
// import apis from "./api.gw";
import oasis from './api.oasis'

let native = {}
let b = util.getBrowser();
//右侧title分享
//{"flag":"1","shareurl":"","sharetitle":"","sharecontent":"","shareimage":""}
native.share = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.oasisshowshare.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.oasisshowshare(jsonsstr);
    } else {
        console.log(jsonsstr)
    }
};
//邀请好友分享
native.navishare = function(jsonsstr) {
    if (b.isios) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.oasisshare) {
            window.webkit.messageHandlers.oasisshare.postMessage(jsonsstr);
        } else {
            var newJson = JSON.parse(jsonsstr)
            location.href = 'oasis://share?&&&' + encodeURI(newJson.sharetitle) + '&&&' + encodeURI(newJson.sharecontent) + '&&&' + encodeURI(newJson.shareurl) + '&&&' + encodeURI(newJson.shareimage);
        }
    } else if (b.isandroid) {
        if (obj4H5 && obj4H5.oasisshare) {
            obj4H5.oasisshare(jsonsstr);
        } else {
            var newJson = JSON.parse(jsonsstr)
            location.href = 'oasis://share?&&&' + encodeURI(newJson.sharetitle) + '&&&' + encodeURI(newJson.sharecontent) + '&&&' + encodeURI(newJson.shareurl) + '&&&' + encodeURI(newJson.shareimage);
        }
    } else {
        console.log(jsonsstr)
    }
};
//opwebview,与app原生约定的打开新web页的方法
native.openwebview = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.openwebview.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.openwebview(jsonsstr);
    } else {
        console.log(jsonsstr)
        var j = JSON.parse(jsonsstr);
        location.href = j.linkurl;
    }
};
//首页球球点击与原生交互
native.setOasisBall = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.setOasisBall.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.setOasisBall(jsonsstr);
    } else {
        console.log(jsonsstr, '原生方法')
    }
};
//掉起原声导航
native.evokeNavigation = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.evokeNavigation.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.evokeNavigation(jsonsstr);
    } else {
        console.log(jsonsstr,'原生方法')
    }
};
//立即购买
native.oasispay = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.oasispay.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.oasispay(jsonsstr);
    } else if (b.isweixin) {
        if (jsonsstr) {
            console.log(jsonsstr)
            let json = JSON.parse(jsonsstr);
            let orderid = json.orderid;
            let trantype = json.trantype;
            // debugger
            location.href = util.domain() + '/wxofficial/pay.html?orderid=' + orderid + '&trantype=' + trantype + '&type=tijian';
        } else {
            util.wxLogin();
        }
    } else {
        console.log(jsonsstr);
        util.downloadUser();
    }
};

//h5收银台，原生环境支付
native.unifiedPayment = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.unifiedPayment.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.unifiedPayment(jsonsstr);
    } else {
        //非原生oasisapp环境
        console.log(jsonsstr);
        //_downloadUser();
    }
};
//立即预约
native.lijiyuyue = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.lijiyuyue.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.lijiyuyue(jsonsstr);
    } else {
        console.log(jsonsstr);
        util.downloadUser();
    }
};
//返回
native.oasisfinish = function() {
    if (b.isios) {
        window.webkit.messageHandlers.oasisfinish.postMessage('{"linkurl":""}');
    } else if (b.isandroid) {
        obj4H5.oasisfinish();
    } else {
        javascript: history.back();
    }
};

//登录
native.oasislogin = function(jsonsstr) {
    if (window.isLoginTime === true) { return };
    window.isLoginTime = true;
    setTimeout(function() {
        window.isLoginTime = false;
    }, 1000);
    if (b.isios) {
        window.webkit.messageHandlers.oasislogin.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.oasislogin();
    } else if (b.isweixin) {
        globle_vue.$router.replace({
            path: '/login',
            query: { url: globle_vue.$router.currentRoute.fullPath }
        })
    } else {
        globle_vue.$router.replace({
            path: '/login',
            query: { url: globle_vue.$router.currentRoute.fullPath }
        })
    }
};

native.setLogin = function(data, access_token) {
    let json = {
        data: data,
        ACCESS_TOKEN: access_token
    }
    if (b.isios) {
        window.webkit.messageHandlers.oasislogin.postMessage(JSON.stringify(json));
    } else if (b.isandroid) {
        obj4H5.oasislogin(json);
    }
}

//订单列表返回我的
native.oasisToMine = function() {
        if (b.isios) {
            window.webkit.messageHandlers.oasisToMine.postMessage('');
        } else if (b.isandroid) {
            obj4H5.oasisToMine();
        } else {
            javascript: history.back();
        }
    }
    //陪诊立即预约
native.elderlyAccompany = function(jsonsstr) {
        if (b.isios) {
            window.webkit.messageHandlers.elderlyAccompany.postMessage(jsonsstr);
        } else if (b.isandroid) {
            obj4H5.elderlyAccompany(jsonsstr);
        } else {
            console.log(jsonsstr);
            util.downloadUser();
        }
    }
    //原生提示框
native.showtoast = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.oasisshowtoast.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.oasisshowtoast(jsonsstr);
    } else {
        console.log(jsonsstr)
    }
};

native.openwebviewForToken = function(jsonsstr) {
    if (b.isios) {
        window.webkit.messageHandlers.openwebviewForToken.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.openwebviewForToken(jsonsstr);
    } else {
        var j = JSON.parse(jsonsstr);
        console.log(j)
        location.href = j.linkurl;
    }
}

//开打原生界面
//pushStr 会诊,固定给1，视频问诊,固定给2,islogin 需要登录 1
native.h5PushApp = function(jsonsstr) {
    console.log(jsonsstr)
    if (b.isios) {
        window.webkit.messageHandlers.h5PushApp.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.h5PushApp(jsonsstr);
    } else {
        alert('仅app支持此功能！')
    }
};

//打开普通页，for banner
native.link = function(linkurl) {
    if (linkurl.indexOf('http') < 0) {
        linkurl = util.domain() + linkurl;
    }
    var params = {};
    params.accountid = util.getaccountid()
    params.webcitycode = localStorage.webcitycode || '110100';
    linkurl = util.moban(params, linkurl)
    var ajson = {};
    ajson.linkurl = linkurl;
    ajson.islogin = "0";
    native.openwebview(JSON.stringify(ajson));
}

/**
 *原生webview页面控制
 * @param jsonsstr String
 * {
 *      navigation:有无导航条（header）：0，没有，1有（默认）
 *      refresh：是否可以下拉刷新：0，不可以，1，可以（默认）
 *}
 */
native.setWebview = function(jsonsstr) {
    console.log('确认唤起导航头');
    if (b.isios) {
        window.webkit.messageHandlers.setWebview.postMessage(jsonsstr);
        console.log('ios唤起');
    } else if (b.isandroid) {
        console.log('安卓唤起');
        obj4H5.setWebview(jsonsstr);
    } else {
        console.log(jsonsstr)
    }
}

native.calldoctor = function() {
    if (b.isios) {
        window.webkit.messageHandlers.calldoctor.postMessage('');
    } else if (b.isandroid) {
        obj4H5.calldoctor('');
    } else {
        console.warn("和原生交互");
    }
}

native.callnurse = function() {
        if (b.isios) {
            window.webkit.messageHandlers.callnurse.postMessage('');
        } else if (b.isandroid) {
            obj4H5.callnurse('');
        } else {
            console.warn("和原生交互");
        }
    }
    // status ==0 回nav 首页，=1 回打开webview的nav页
native.finishWebViewNav = function(jsonstr) {
    if (b.isios) {
        window.webkit.messageHandlers.finishWebViewNav.postMessage(jsonstr);
    } else if (b.isandroid) {
        obj4H5.finishWebViewNav(jsonstr);
    } else {
        console.warn("和原生交互");
        history.go(-1);
    }
}


native.live = function(cardno) {

    //var accountid = util.getaccountid(); //util.getCookie("accountid")
    // var ACCESS_TOKEN = util.getACCESS_TOKEN();

    // if (!accountid) {
    //     alert('没有拿到用户id')
    //     // location.href = '/video/Member';
    //     native.link(location.origin + '/video/Member');
    //     return;
    // }
    native.link(location.origin + '/video');
    // location.href = '/video';
    // var info = {
    //         accountid: accountid
    //     }
    //     // var json = `?info={accountid:${accountid}}`;
    // oasis.checkUserCan(info)
    //     .then((res) => {
    //         console.log(res, '====================')
    //         if (res.isVideoMember) {
    //             //是vip,pushStr 固定给2，islogin 需要登录 1
    //             //      if (res.staff) {
    //             var ajson = {};
    //             ajson.pushStr = "2";
    //             ajson.islogin = "1";
    //             //        ajson.mobile = res.staff.mobile;
    //             //        ajson.name = res.staff.name;
    //             //        ajson.icon = res.staff.icon;
    //             if (cardno) {
    //                 ajson.cardno = cardno;
    //                 console.log(cardno, 'true')
    //             } else if (res.clubCard[0]) {
    //                 ajson.cardno = res.clubCard[0].cardno;
    //                 util.setlocalcardno(res.clubCard[0].cardno)
    //             }
    //             //        console.log(ajson)
    //             // native.h5PushApp(JSON.stringify(ajson));
    //             //      } else {
    //             //        var ajson = {};
    //             //        ajson.message = "服务人员全忙，请您稍后再试！";
    //             //        native.showtoast(JSON.stringify(ajson));
    //             //      }
    //         } else {
    //             //不是vip
    //             alert('不是vip')
    //             location.href = '/video/Member';
    //         }
    //     })
}
native.link = function(linkurl) {
    if (linkurl.indexOf('http') < 0) {
        linkurl = util.domain() + linkurl;
    }
    var params = {};
    params.accountid = util.getaccountid()
    params.webcitycode = localStorage.webcitycode || '110100';
    linkurl = util.moban(params, linkurl)
    var ajson = {};
    ajson.linkurl = linkurl;
    ajson.islogin = "0";
    native.openwebview(JSON.stringify(ajson));
}

native.oasispay = function(jsonsstr) {
    if (util.getBrowser().isios) {
        window.webkit.messageHandlers.oasispay.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.oasispay(jsonsstr);
    } else {
        console.log(jsonsstr);
        _downloadUser();
    }
};

//门诊预约 doctorid
native.clickMedicalCareDetail = function(str) {
        if (b.isios) {
            window.webkit.messageHandlers.clickMedicalCareDetail.postMessage(str);
        } else if (b.isandroid) {
            obj4H5.clickMedicalCareDetail(str);
        } else {
            console.log(str);
        }
    }
    //电话咨询 doctoraccountid doctorname  doctorid
native.commitorderdoctor = function(str) {
    if (b.isios) {
        window.webkit.messageHandlers.commitorderdoctor.postMessage(str);
    } else if (b.isandroid) {
        obj4H5.commitorderdoctor(str);
    } else {
        console.log(str);
    }
}

native.commitordernurse = function(str) {
  if (b.isios) {
    window.webkit.messageHandlers.commitordernurse.postMessage(str);
  } else if (b.isandroid) {
    obj4H5.commitordernurse(str);
  } else {
    console.log(str);
  }
}

// li start
// native.getPosition = function() {
//         let position = null
//         if (b.isios) {
//           //触发iOS获取位置
//           window.webkit.messageHandlers.getPosition.postMessage('{}');
//
//         } else if (b.isandroid) {
//             position = obj4H5.getPosition();
//         } else {
//             console.log();
//         }
//         // console.log(position, 'position')
//         return position
//             // alert(position)
//     }
// li end

native.getPosition = function() {

    return new Promise(function(resolve, reject) {
        let def = {}
        def.area = '朝阳区'
        def.city = '北京市'
        def.cityCode = '110100'
        def.latitude = '39.997382'
        def.longitude = '116.408619'
        if (b.isios) {
            //触发iOS获取位置
            window.getPosition = function(position) {
                var newPosition = JSON.parse(position)
                if (newPosition.status == 1) {
                    resolve(newPosition);
                } else {
                    resolve(def);
                }
            }
            window.webkit.messageHandlers.getPosition.postMessage('{}');
        } else if (b.isandroid) {
            let position = null
            position = obj4H5.getPosition();
            var newPosition = JSON.parse(position)
            if (newPosition.status == 1) {
                resolve(newPosition);
            } else {
                resolve(def);
            }
        } else {
            resolve(def);
        }
    })

}
native.setStatusBar = function(jsonsstr) { //修改状态栏的背景颜色以及文字颜色
    if (b.isios) {
        window.webkit.messageHandlers.setStatusBar.postMessage(jsonsstr);
    } else if (b.isandroid) {
        obj4H5.setStatusBar(jsonsstr);
    } else {
        console.log(jsonsstr)
    }
};

function _downloadUser() {
    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.lcworld.oasismedical";
}


export default native;



// WEBPACK FOOTER //
// ./src/lib/native.js